/**
 * The modules accordion tracks the open card by index; keep it on the same
 * module when others are removed or moved. It used to stay on the position,
 * so removing a module above the open one opened its neighbour (DEV-539).
 */
export function openIndexAfterRemove(
  openIndex: number | null,
  removedIndex: number,
): number | null {
  if (openIndex === null || openIndex === removedIndex) return null;
  return openIndex > removedIndex ? openIndex - 1 : openIndex;
}

export function openIndexAfterMove(
  openIndex: number | null,
  fromIndex: number,
  toIndex: number,
): number | null {
  if (openIndex === null) return null;
  if (openIndex === fromIndex) return toIndex;
  if (fromIndex < openIndex && toIndex >= openIndex) return openIndex - 1;
  if (fromIndex > openIndex && toIndex <= openIndex) return openIndex + 1;
  return openIndex;
}
